"use client";

import { useSelection, useToken } from "@trydig/centra/client";
import type { BaseSelection } from "@trydig/centra-types/selection";
import { useEffect, useRef } from "react";
import { useGeo } from "@/i18n/routing";
import type { ProductDetails } from "../centra";
import { klaviyoTracker } from "./tracker";

export const KlaviyoStartCheckout = () => {
	const token = useToken();

	const { data: selection } = useSelection();
	const hasRan = useRef(false);

	useEffect(() => {
		if (selection) {
			if (hasRan.current) return;

			klaviyoTracker.startCheckout(
				selection.selection as BaseSelection,
				selection.token,
			);
			hasRan.current = true;
		}
	}, [selection]);

	return null;
};

export const KlaviyoViewItem = ({ product }: { product: ProductDetails }) => {
	useEffect(() => {
		klaviyoTracker.viewProduct(product);
	}, [product]);

	return null;
};

export const KlaviyoIdentify = () => {
	const { data: selection } = useSelection();

	useEffect(() => {
		if (
			selection?.selection?.address?.email &&
			selection?.selection?.address?.email.trim() !== ""
		) {
			klaviyoTracker.identify(selection?.selection?.address?.email);
		}
	}, [selection?.selection?.address?.email]);

	return null;
};

export const KlaviyoLocaleIdentify = () => {
	const { language, country } = useGeo();

	useEffect(() => {
		klaviyoTracker.identifyLocale(language, country);
	}, [language, country]);

	return null;
};
